import GiftCardDisclaimer from '@moncler/components/product/GiftCardDisclaimer';
import api from '@utils/api';
import classNames from 'classnames';
import React, { Suspense, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
const ExpressPaymentsButtons = React.lazy(() => import(/* webpackChunkName: "component-expresspaymentsbuttons" */ './ExpressPaymentsButtons'));
const ExpressPaymentsMinicart = (props) => {
    var _a;
    const { t } = useTranslation();
    const { modalExpressPaymentsOpen, isOpen, onLoad } = props;
    const [paymentMethods, setPaymentMethods] = useState();
    const [adyenConfig, setAdyenConfig] = useState();
    const [bag, setBag] = useState();
    const [closeTs, setCloseTs] = useState(); // trick to forse method deselection
    const backRef = useRef(null);
    const { minicart } = useSelector((state) => state.minicart);
    const firstRender = useRef(true);
    useEffect(() => {
        if (modalExpressPaymentsOpen) {
            setTimeout(() => {
                var _a;
                (_a = backRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1000);
        }
        if (modalExpressPaymentsOpen && firstRender.current) {
            firstRender.current = false;
            api.getPaymentMethods().then((data) => {
                onLoad();
                setPaymentMethods(data);
            });
            api.getAdyenConfig().then((data) => {
                onLoad();
                setAdyenConfig(data);
            });
            api.getFullCart().then((data) => {
                onLoad();
                setBag(data);
            });
        }
    }, [modalExpressPaymentsOpen]);
    useEffect(() => {
        api.getFullCart().then((data) => {
            setBag(data);
            setCloseTs(new Date());
            props.onClose();
        });
    }, [minicart === null || minicart === void 0 ? void 0 : minicart.items]);
    return (React.createElement("div", { id: "expressCheckoutMinicart", className: classNames('minibag__expresspayment', { open: isOpen }) }, !(((_a = bag === null || bag === void 0 ? void 0 : bag.items) === null || _a === void 0 ? void 0 : _a.length) > 0) || window.noguestcheckout || window.noexpresscheckout || (bag === null || bag === void 0 ? void 0 : bag.exchangeModel) ? undefined : (React.createElement(React.Fragment, null,
        React.createElement("button", { className: "minibag__expresspayment__intro button button--tertiary button--arrow-left", ref: backRef, onClick: () => {
                setCloseTs(new Date());
                props.onClose();
            }, "aria-label": t('button.close') }, t('checkout.expresscheckout')),
        React.createElement(GiftCardDisclaimer, { checkouturl: props.checkouturl, bag: minicart }),
        React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null,
                React.createElement("button", { className: "button button--secondary", disabled: true }, "loading"),
                React.createElement("button", { className: "button button--secondary", disabled: true }, "loading"),
                React.createElement("button", { className: "button button--secondary", disabled: true }, "loading")) },
            React.createElement(ExpressPaymentsButtons, Object.assign({}, props, { adyenConfig: adyenConfig, paymentMethods: paymentMethods, bag: bag, noDisclaimer: true, reloadtimestamp: closeTs })))))));
};
export default ExpressPaymentsMinicart;
